module.exports = __webpack_public_path__ + "img/itto.cf5d082b.webp";